(() => {
  if (window.__lunverkCartFixLoaded) return;
  window.__lunverkCartFixLoaded = true;

  const cartChangeUrl = () => window.routes?.cart_change_url || '/cart/change.js';
  let cartActionPending = false;

  function requestConfig(body) {
    if (typeof window.fetchConfig === 'function') return { ...window.fetchConfig(), body };
    return {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body,
    };
  }

  function getContext(element) {
    if (element?.closest('#CartDrawer')) return 'drawer';
    if (element?.closest('#MainContent')) return 'page';
    return null;
  }

  function replaceDrawerFromState(state) {
    const drawerSection = state.sections?.['cart-drawer'];
    if (drawerSection) {
      const freshDoc = new DOMParser().parseFromString(drawerSection, 'text/html');
      const freshInner = freshDoc.querySelector('#CartDrawer .drawer__inner');
      const currentInner = document.querySelector('#CartDrawer .drawer__inner');
      if (freshInner && currentInner) currentInner.innerHTML = freshInner.innerHTML;
    }

    const drawer = document.querySelector('cart-drawer');
    drawer?.classList.toggle('is-empty', state.item_count === 0);

    const iconSection = state.sections?.['cart-icon-bubble'];
    if (iconSection) {
      const iconDoc = new DOMParser().parseFromString(iconSection, 'text/html');
      const freshIcon = iconDoc.querySelector('#cart-icon-bubble');
      const currentIcon = document.querySelector('#cart-icon-bubble');
      if (freshIcon && currentIcon) currentIcon.innerHTML = freshIcon.innerHTML;
    }

    if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS?.cartUpdate) {
      window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
        source: 'lunverk-cart-fix',
        cartData: state,
      });
    }
  }

  async function removeLine(line, context) {
    if (cartActionPending) return;
    cartActionPending = true;

    try {
      const payload = {
        line: Number(line),
        quantity: 0,
      };

      if (context === 'drawer') {
        payload.sections = ['cart-drawer', 'cart-icon-bubble'];
        payload.sections_url = window.location.pathname;
      }

      const body = JSON.stringify(payload);
      const response = await fetch(cartChangeUrl(), requestConfig(body));
      if (!response.ok) throw new Error(`Cart change failed: ${response.status}`);

      const state = await response.json();
      if (state?.errors) throw new Error(typeof state.errors === 'string' ? state.errors : 'Cart change failed');

      if (context === 'drawer') {
        replaceDrawerFromState(state);
        cartActionPending = false;
      } else {
        window.location.reload();
      }
    } catch (error) {
      cartActionPending = false;
      const fallback = `/cart/change?line=${encodeURIComponent(line)}&quantity=0`;
      window.location.assign(fallback);
    }
  }

  function stopEvent(event) {
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
  }

  document.addEventListener(
    'click',
    (event) => {
      const removeButton = event.target.closest('cart-remove-button');
      if (removeButton) {
        const context = getContext(removeButton);
        const line = removeButton.dataset.index;
        const control = event.target.closest('button, a');

        if (context && line && control && removeButton.contains(control)) {
          stopEvent(event);
          removeButton.setAttribute('aria-busy', 'true');
          removeLine(line, context);
          return;
        }
      }

      const minusButton = event.target.closest('quantity-input .quantity__button[name="minus"]');
      if (!minusButton) return;

      const context = getContext(minusButton);
      if (!context) return;

      const quantityInput = minusButton.closest('quantity-input')?.querySelector('.quantity__input[data-index]');
      if (!quantityInput) return;

      const currentValue = Number(quantityInput.value || 0);
      const step = Number(quantityInput.step || 1) || 1;
      const nextValue = currentValue - step;

      if (nextValue <= 0) {
        stopEvent(event);
        removeLine(quantityInput.dataset.index, context);
      }
    },
    true
  );

  document.addEventListener(
    'change',
    (event) => {
      const quantityInput = event.target.closest('.quantity__input[data-index]');
      if (!quantityInput) return;

      const context = getContext(quantityInput);
      if (!context) return;

      if (Number(quantityInput.value) <= 0) {
        stopEvent(event);
        removeLine(quantityInput.dataset.index, context);
      }
    },
    true
  );
})();
